export const environment = {
  production: false,
  baseApiUrl: "https://autopets.sso.staging.iothings.site",
  apiKey: "BZub0HyApt9tRDx5k2JSd8SUVm3FxlYOaZ4lxXHt",
  autopetsLr3BaseApi: "https://v2.api.whisker.staging.iothings.site",
  autopetsLr3ApiKey: "dmakTT4rAN6rbw3RAhITBegS5V8Odo86D1NlnOKg"
};
